import React from 'react'
import { Typography, Box, Container } from '@material-ui/core'
import { useGetOrganization } from 'hooks/useGetOrganization'

const ApplicationHeader: React.FC = () => {
  const { organization } = useGetOrganization()
  const organizationName = organization?.whiteLabel ? organization?.name || '' : 'EXEC'

  return (
    <Container maxWidth='md'>
      <Box my={4}>
        <Typography variant='h5'>Thank you for your interest in {organizationName} membership.</Typography>
      </Box>

      <Box mb={4}>
        <Typography variant='body2'>
          Please complete the form below with additional details about yourself, your company, and provide a bit more
          information about your interest in {organizationName}. By completing this form, you will take the first step
          to enjoying the privileged Membership benefits of {organizationName} and fast-track your opportunity to join.
        </Typography>
      </Box>
    </Container>
  )
}

export default ApplicationHeader
